export enum AirbnbCancellationPolicy {
  FLEXIBLE = 'flexible',
  MODERATE = 'moderate',
  BETTER_STRICT_WITH_GRACE_PERIOD = 'better_strict_with_grace_period',
  STRICT = 'strict',
  SUPER_STRICT_30 = 'super_strict_30',
  SUPER_STRICT_60 = 'super_strict_60',
}
